import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const addProcessRemark = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/addprocessremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const uploadMaintainPicture = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/uploadpositioningdevicefittingspicture/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const removeMaintainPicture = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefittingstype/removepositioningdevicefittingspicture/' + params.positioningdevicefittingstypepicId + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}
